import { useProjectShipmentsProcessingStats } from '@/core/api/queries';
import { useQueryClient } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';


export const ProcessingStatus = ({ projectId }: { projectId: string }) => {
    const { data } = useProjectShipmentsProcessingStats(projectId);
    const [prevProcessingCount, setPrevProcessingCount] = useState(data?.processingCount);
    const queryClient = useQueryClient();

    useEffect(() => {
        if (data?.processingCount !== prevProcessingCount) {
            setPrevProcessingCount(data.processingCount);
            queryClient.invalidateQueries({
                queryKey: ['shipments', 'project', projectId, ''],
                exact: false,
            });
        }
    }, [data?.processingCount, prevProcessingCount, queryClient]);

    if (!data || data?.processingCount === 0) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span>
                Processing: {data.processingCount} / {data.totalShipments}
            </span>
        </div>
    );
};